export default "__VITE_ASSET__ClzBPb_G__"